/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum ScheduleDailyKind {
    EveryDay = 0,
    WeekDays = 1,
    SelectedDays = 2,
}
